/// <reference path="../_references.ts"/>

module App.Customer {
	import TitleBarService = App.Helpers.TitleBarService;
	import AppRootScope = App.Administrative.AppRootScope;

	export class CustomerSearchController {
		static $inject = ['$rootScope', 'CustomerService', 'SelectedCustomer', 'TitleBarService', '$state'];

		isSearching: boolean;
		results: Customer[];
		query: string;

		constructor(
			private $rootScope: AppRootScope,
			public CustomerService: CustomerService,
			public SelectedCustomer: SelectedCustomer,
			public TitleBarService: TitleBarService,
			public $state: ng.ui.IStateService
		) {
			TitleBarService.set('Home')
		}

		addCustomer():void {
			const vm = this;

			vm.SelectedCustomer.clearSearchResults();
			vm.$state.go('zipSolutions.home.customer.create');
		}

		selectCustomer(customer: Customer) {
			const vm = this;

			vm.SelectedCustomer.set(customer);
			vm.$state.go('zipSolutions.home.service-request');
		}

		search(query: string) : void {
			let vm = this;

			vm.results = [];
			vm.isSearching = true;
			vm.$rootScope.app.stopAppLoading();

			if(query.length > 2) {
				this.CustomerService.search(vm.SelectedCustomer.searchQuery).then((response) => {
					vm.SelectedCustomer.setSearchResultsCache(response.data);
					vm.isSearching = false;
					vm.$rootScope.app.stopAppLoading();
				});
			}
		}
	}
}
